import {reportAd, getButStatus, adUserReport} from "@/api/ad";
import {showToast} from "vant";

export function checkTk() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return userAgent.includes('musical_ly') || userAgent.includes('TikTok');
}

export function getCookieValue(name) {
    let matches = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    if (matches) {
        return matches.pop();
    }

    // 如果 cookie 中没有，则尝试从 URL 中获取
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name) || ''; // 返回参数值或空字符串
}

export function getUrlParameter(name) {
    name = name.replace(/[[]/, '[').replace(/[\]]/, ']'); // 修改这里
    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    let results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export function getDeviceInfo() {
    const ua = navigator.userAgent;
    let deviceType = "unknown";
    if (/iPad/.test(ua)) {
        deviceType = "iPad";
    } else if (/iPod/.test(ua)) {
        deviceType = "iPod";
    } else if (/iPhone/.test(ua)) {
        deviceType = "iPhone";
    } else if (/Android/.test(ua)) {
        deviceType = "Android";
    } else if (/Windows Phone/.test(ua)) {
        deviceType = "Windows Phone";
    }

    return deviceType;
}

export function getTimeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
}

export function getTimeZoneOffset() {
    // 获取本地时区偏差，以分钟为单位
    let offset = new Date().getTimezoneOffset();
    // 将分钟转换为小时，并改变符号，因为getTimezoneOffset()的返回值与常规时区表示相反
    return -offset / 60;
}


export function downloadAppN(){
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        window.location.href = 'https://itunes.apple.com/app/id6740176167';
    }else{
        window.location.href = 'https://play.google.com/store/apps/details?id=net.mangatime.app';
    }
}


export function downloadApp(appid, rd, pixel_id, page, comic_id = 0){
    try {
        window.ttq.track('ClickButton');
    } catch (error) {
        console.log("ClickButton Err:", error);
    }

    // iOS
    // let iosUrlZoomins = 'https://itunes.apple.com/app/id6503939849';
    //let iosUrlNeopad = 'https://itunes.apple.com/app/id6505052823';
    let iosUrlPixCho = 'https://itunes.apple.com/app/id6680173118';
    let iosUrlMosPix = 'https://itunes.apple.com/app/id6736964014';
    let iosUrlArt = 'https://itunes.apple.com/app/id6739805663';
    let iosUrlCv = 'https://apps.apple.com/app/id6744626686';
    // Android
    let androidUrl = 'https://play.google.com/store/apps/details?id=com.xm.manga';
    let androidUrlPixCho = 'https://play.google.com/store/apps/details?id=com.stars.glo';
    let androidUrlEpi = 'https://play.google.com/store/apps/details?id=com.stars.epicraft';

    // 检测用户设备
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        // iOS
        if( appid == 5 ){
            window.location.href = iosUrlMosPix;
        }else if(appid == 6){
            window.location.href = iosUrlCv;
        }else if(appid == 7){
            window.location.href = iosUrlArt;
        }else{
            window.location.href = iosUrlPixCho;
        }
    } else if (/android/i.test(userAgent)) {
        // if( page == 'thr-info-dwn' || page == 'thr-list-dwn' ){
        //     let hostname = window.location.hostname
        //     const parts = hostname.split('.');
        //     let head = 'https://img.';
        //     if( parts[1] == 'x6manga' || parts[1] == 'uuemo' || parts[1] == 'skyreels' || parts[1] == 'mangabuz' || parts[1] == 'mayonn' ){
        //         head = 'https://oss.';
        //     }
        //     let domain = head + parts[1] + '.' + parts[2];
        //     let dwn_link = domain + '/app/NeoPad_1.0.0.apk';
        //     window.location.href = dwn_link
        // }else {
            // Android
            if( appid == 1 ){
                window.location.href = androidUrl;
            }else if(appid == 9){
                window.location.href = androidUrlEpi;
            }else{
                window.location.href = androidUrlPixCho;
            }
        // }
    } else {
        showToast('Please click on download on your mobile device');
    }

    report(appid, rd, pixel_id, page, comic_id)
}

export function clickBut(){
    try {
        window.ttq.track('SubmitForm');
    } catch (error) {
        console.log("SubmitForm Err:", error);
    }
}

export function report(appid, rd, pixel_id, page, comic_id = 0){
    try {
        const content_id = comic_id ? comic_id : 10000;
        window.ttq.track('ViewContent',
        {
            content_id: content_id,
        });
    } catch (error) {
        console.log("ViewContent Err:", error);
    }

    let ttp = getCookieValue('_ttp');
    let ttclid = getCookieValue('ttclid');

    if( !ttp && !ttclid ){
        return;
    }

    let source = getUrlParameter('utm_source');
    let medium = getUrlParameter('utm_medium');
    let ad_id = getUrlParameter('utm_ad_id');
    let adset_id = getUrlParameter('utm_adset_id');
    let campaign_id = getUrlParameter('utm_campaign_id');
    let campaign_name = getUrlParameter('utm_campaign_name');
    let adset_name = getUrlParameter('utm_adset_name');
    let ad_name = getUrlParameter('utm_ad_name');
    let channel = getUrlParameter('utm_channel');
    let device = getDeviceInfo();
    let preferredLanguage = navigator.language;
    let timeZone = getTimeZone();
    let width = window.screen.width;
    let height = window.screen.height;

    const formdata = new FormData()
    formdata.append('appid', appid)
    formdata.append('rd', rd)
    formdata.append('pixel_id', pixel_id)
    formdata.append('comic_id', comic_id)
    formdata.append('source', source)
    formdata.append('medium', medium)
    formdata.append('page', page)
    formdata.append('channel', channel)
    formdata.append('language', preferredLanguage)
    formdata.append('time_zone', timeZone)
    formdata.append('ttp', ttp)
    formdata.append('ttclid', ttclid)
    formdata.append('ad_id', ad_id)
    formdata.append('adset_id', adset_id)
    formdata.append('campaign_id', campaign_id)
    formdata.append('ad_name', ad_name)
    formdata.append('adset_name', adset_name)
    formdata.append('campaign_name', campaign_name)
    formdata.append('device', device)
    formdata.append('width', width)
    formdata.append('height', height)

    reportAd(formdata).then()
}


// 用户举报
export function userReport(appid, rd, pixel_id, reason_id, reason_text, images){
    let ttp = getCookieValue('_ttp');
    let ttclid = getCookieValue('ttclid');
    let timeZone = getTimeZone();
    let device = getDeviceInfo();
    let time_zone_offset = getTimeZoneOffset()

    const formdata = new FormData()
    formdata.append('rd', rd)
    formdata.append('ttp', ttp)
    formdata.append('ttclid', ttclid)
    formdata.append('appid', appid)
    formdata.append('reason_id', reason_id)
    formdata.append('reason', reason_text)
    formdata.append('pixel_id', pixel_id)
    formdata.append('device', device)
    formdata.append('time_zone', timeZone)
    formdata.append('time_zone_offset', time_zone_offset)

    for (let img of images) {
        if (!imgType(img.file)) {
            return;
        }

        formdata.append("imgs[]", img.file);
    }

    return adUserReport(formdata)
}


export function imgType(file) {
    const isImg = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg'
    const isLt5M = file.size / 1024 / 1024 < 3

    if (!isImg) {
        //showToast('Please upload images in PNG, JPEG, or JPG format.')
        return false;
    }
    if (!isLt5M) {
        //showToast('The uploaded file size must not exceed 5MB!')
        return false;
    }

    return true;
}


export function getAppid(){
    // 检测用户设备
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;

    let domain_map = {
        'tk': '1',
        'tkzm': '4',
        'tknp': '3',
        'tkgl': '4',
        'tkms': '5',
        'tkcv': '6',
        'tkat': '7',
        'tkep': '9',
    }
    let hostname = window.location.hostname
    const parts = hostname.split('.');
    let prefix = parts[0];

    if (!domain_map[prefix]) {
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return domain_map['tkgl'];
        }else{
            return domain_map['tk'];
        }
    }else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        if(prefix != 'tkgl' && prefix != 'tkms' && prefix != 'tkat' && prefix != 'tkcv'){
            return domain_map['tkgl'];
        }
    }

    return domain_map[prefix]
}


export function getAppidNew(appid){
    if (!appid){
        return getAppid();
    }

    let appid_map = {
        '1': 1, // mb
        '2': 4, // zm
        '3': 3, // np
        '4': 4, // pc
        '5': 5, // mp
        '6': 6, // cv
        '7': 7, // at
        '9': 9, // ep
    }

    let userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (!appid_map[appid]) {
        if (/android/i.test(userAgent)) {
            return 4;
        }else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return 4;
        }else{
            return 1;
        }
    }

    if (/android/i.test(userAgent)) { // 只有一个安卓情况下
        if (appid == 1 || appid == 4 || appid == 9){
            return appid;
        }else{
            return 4;
        }
    }else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        if (appid == 4 || appid == 5 || appid == 6 || appid == 7){
            return appid;
        }else{
            return 4;
        }
    }

}

export function getShowBut(){
    return getButStatus().then(response => {
        const { data } = response.data
        return data.status;
    }).catch(error => {
        console.error('load err:', error);
        return 0
    });
}

